<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	import { FlexibleCard, PlainTable, Button, Modal, ListItem } from '@Shelly/shelly-design-system';
	import { dateFormat } from 'src/helpers/date_helper';
	import LayerChartRenderer from 'src/components/Chart/LayerChart/LayerChartRenderer.svelte';
	import { getLastSessionEvents } from 'src/helpers/xt1_helpers/ev_charger/ev_charger_event_log_helpers';
	import {
		getSessionsInfo,
		getSessionsStatus,
	} from 'src/helpers/xt1_helpers/ev_charger/ev_charger_session_info_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { StatusIndicatorWorkingStates } from 'src/helpers/xt1_helpers/ev_charger/ev_charger_helpers';
	import type {
		SessionEvents,
		SessionInfo,
	} from 'src/helpers/xt1_helpers/ev_charger/ev_charger_session_info_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device: Device,
		workState: {
			state: StatusIndicatorWorkingStates;
			title: string;
			subtitle: string;
		};

	let sessionsStatus: SessionInfo[] = [];
	let sessionsInfo: SessionInfo[] = [];
	let lastSessionEvents: SessionEvents = null;
	let sessionModal = false;

	const updateSessionInfo = async () => {
		if (!lastSessionEvents) {
			lastSessionEvents = await getLastSessionEvents(
				device,
				workState.state === 'completed' ? 'charging' : 'plug',
			);
		}
		sessionsInfo = getSessionsInfo(lastSessionEvents, 'm-d H:i');
	};
	$: sessionsStatus = getSessionsStatus(device.id, lastSessionEvents);

	onMount(updateSessionInfo);
</script>

{#if sessionsStatus.length > 0}
	<FlexibleCard
		backgroundColor={$showNewLayout ? '--color-0' : undefined}
		class="mb-s"
		padding="m"
		mainContentPrioritySlot="both"
		header={$format('label_last_session_summary', {
			default: 'Last session summary',
		})}
	>
		<PlainTable class="width-full">
			<tbody>
				{#each [...sessionsStatus, ...sessionsInfo] as session}
					<tr>
						<th>{session.title}</th>
						<td class={session?.color ? session.color : ''}>{session.state}</td>
					</tr>
				{/each}
			</tbody>
		</PlainTable>
		{#if lastSessionEvents?.statistics}
			<PlainTable class="width-full">
				<Button
					variant="secondary"
					class="mt-s width-full"
					size="m"
					on:click={() => {
						sessionModal = true;
					}}
				>
					{$format('button_more_details', {
						default: 'More details',
					})}
				</Button>
			</PlainTable>
		{/if}
	</FlexibleCard>
{/if}

{#if lastSessionEvents?.statistics}
	<Modal
		on:close={() => (sessionModal = false)}
		showModal={sessionModal}
		backdropClose
		title={dateFormat(lastSessionEvents.session_start, 'd-m-Y')}
	>
		<svelte:fragment slot="content">
			<LayerChartRenderer
				chartData={{
					...lastSessionEvents.statistics.chartData,
					type: 'area',
				}}
			/>
			<div class="grid mt-l">
				{#each [...sessionsStatus, ...sessionsInfo] as session}
					<ListItem
						icon={session.icon}
						title={session.title}
						viewType="fullColored"
						progress={{ title: session.state, color: session.color }}
						listItemBgColor="--color-1"
					/>
				{/each}
			</div>
		</svelte:fragment>
	</Modal>
{/if}

<style>
	.grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
		grid-gap: var(--spacing-s);
	}
</style>
